import script from "./SystemSettingsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SystemSettingsPage.vue?vue&type=script&setup=true&lang=ts"

import "./SystemSettingsPage.vue?vue&type=style&index=0&id=789a5026&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-789a5026"]])

export default __exports__